module.exports = __webpack_public_path__ + "img/banner.17f13ec4.jpg";